import { useEffect, useState } from "react";
import { Button, Drawer, Modal, message } from "antd";
import { authRequest } from "../../../../../common/request/authRequest";
import { useAuth } from "../../../../../store/AuthContext/AuthContext";
import { authFetch } from "../../../../../common/request/authFetch";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { ButtonLZ } from "../../../../components/design/Buttons/ButtonLZ";
import { NewCategoryModal } from "../../../menuReviews/3_1_Reviews/Reviews/drawer/NewCategoryModal";
import { NewCompetitorsModal } from "./NewCompetitorsModal";
import { DrawerPanelTitle, drawerPanelStyles } from "../../../common/Drawers/DrawerPanelTitle";

export const AddCompetitorsDrawer = (props: { onClose: any, benchmarckId: string }) => {    
    
  const [openModal, setOpenModal] = useState<any>(null);
  const [updateData, setUpdateData] = useState(false);
  const [competitors, setCompetitors] = useState<any>(null);
  const { projectGroup } = useAuth();    

  useEffect(() => {
        
    authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/competitors`, {})
      .then((response) => {
        setCompetitors(response);                  
      }).catch(() => {message.error('Error al cargar competidores')});
      }
  ,[updateData]); 

  const deleteCompetitor = async (competitor: string): Promise<void> => {
		
    const data = {
			competitor: competitor,
			isMyBusiness: false
		};
    await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/competitors`,{ method: 'DELETE', data})
        .then((res) => {
            if (res) {
                message.success('Competidor borrado de forma satisfactoria', 3);
                setUpdateData(!updateData);                 
            } else {
              message.error('Problema al borrar el competidor', 3);
            }
        })
    }    

    return (        
      <Drawer placement="right"
        width={'40%'}
        title={<DrawerPanelTitle title="Competidores" />}
        onClose={() => props.onClose(false)} open={true}
        {...drawerPanelStyles}>

        <h3>Mi Negocio</h3>        
        
        <div style={{ display: 'flex', justifyContent:'space-between', gap: '10px', alignItems: 'center', marginTop: '16px', marginBottom: '16px' }}>
            <span style={{minWidth: '50px', borderRadius:'5px', margin:'10px 20px', border:'solid 1px #108ee9', color:'#108ee9', padding:'1px 6px'}}><small><b>{competitors?.myBusiness && <span>{competitors.myBusiness}</span> }</b></small></span>                    
            <ButtonLZ size='small' type='ghost' onClick={() => { setOpenModal({isMyBusiness: true}) }}>
                <PlusOutlined/> Añadir mi Negocio
            </ButtonLZ>
        </div>     
        <br/>
        <h3>Competidores</h3>
        {competitors?.competitors.map((row: any, idx: number) => {
                return (
                    <div key={idx} style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>                            
                        <div>
                            <div style={{minWidth: '50px', borderRadius:'5px', margin:'10px 20px', border:'solid 1px #108ee9', color:'#108ee9', padding:'1px 6px'}}><small><b>{row}</b></small></div>
                        </div>
                        <Button shape='round' size='small' type='link' style={{ color: 'grey' }} 
                                  onClick={() => {
                                        Modal.confirm({
                                            title: 'Confirmas que quieres eliminar este competidor',
                                            okText: t('dictionary.confirm'),
                                            cancelText: t('dictionary.cancel'),
                                            onOk: () => deleteCompetitor(row)
                                        })
                                    }}>
                                <DeleteOutlined style={{ fontSize: '12px' }} />
                                <small> Eliminar competidor</small>
                        </Button>

                    </div>
                )
                })    
            }                
            <br/>
            <div style={{ display: 'flex', justifyContent:'flex-end', gap: '10px', alignItems: 'center', marginTop: '16px', marginBottom: '16px' }}>
                <ButtonLZ size='small' type='ghost' onClick={() => { setOpenModal({isMyBusiness:false}) }} /*disabled={!hasAutomatedRole}*/>
                    <PlusOutlined/> Añadir competidor
                </ButtonLZ>
            </div>     
            {openModal && <NewCompetitorsModal isMyBusiness={openModal.isMyBusiness} onFinish={() => {setOpenModal(null); setUpdateData(!updateData)}} onClose={() => {setOpenModal(null)}} />}   
      </Drawer>        
    );
};
